<template>
    <v-container fluid class="pa-0">
        <v-card
            flat
            class="grey lighten-5 mt-0 pt-0"
            :loading="$apollo.queries.salesOrderProduct.loading"
        >
            <v-card-text v-if="$apollo.queries.salesOrderProduct.loading">
                <v-row class="mx-0">
                    <v-col cols="12">loading...</v-col>
                </v-row>
            </v-card-text>

            <!-- if single plant container -->
            <v-form
                ref="form"
                v-model="valid"
                v-else-if="salesOrderProduct.quantityPerContainer == 1"
            >
                <!-- Product Items -->
                <v-card-text v-if="salesOrderProduct.product">
                    <v-row class="mx-0">
                        <v-col cols="12">
                            <v-simple-table class="mx-0">
                                <thead>
                                    <tr>
                                        <th class="text-left">Priority</th>
                                        <th class="text-left">Plant</th>
                                        <th class="text-left">Pot Size</th>
                                        <th class="text-left">Color</th>
                                        <th class="text-left">Environment</th>
                                        <th class="text-left">Tag</th>
                                        <th class="text-right">Inventory</th>
                                        <th class="text-right">Available</th>
                                        <th class="text-center">Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(productItem,
                                        index) in salesOrderProduct.product
                                            .productItemSet.edges"
                                        :key="index"
                                    >
                                        <td>{{ productItem.node.priority }}</td>
                                        <td>
                                            {{ productItem.node.plant.name }}
                                        </td>
                                        <td>
                                            {{
                                                productItem.node.potSize
                                                    .potSizeCm
                                            }}
                                            cm
                                        </td>
                                        <td>
                                            {{ productItem.node.color.color }}
                                        </td>
                                        <td>
                                            {{
                                                productItem.node.environment
                                                    .environment
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                productItem.node.tag
                                                    ? productItem.node.tag.tag
                                                    : "-"
                                            }}
                                        </td>
                                        <td
                                            class="text-right"
                                            :set="
                                                (plantInventory = getAvailableInventory(
                                                    productItem.node
                                                ))
                                            "
                                        >
                                            <span
                                                v-if="
                                                    plantInventory <
                                                        productItem.node
                                                            .quantity
                                                "
                                                class="error--text"
                                            >
                                                {{ plantInventory }}
                                                <v-icon class="ml-1 error--text"
                                                    >warning</v-icon
                                                >
                                            </span>
                                            <span v-else>{{
                                                plantInventory
                                            }}</span>
                                        </td>
                                        <td
                                            class="text-right"
                                            :set="
                                                (availableInventory = getCustomerAvailableInventory(
                                                    productItem.node
                                                ))
                                            "
                                        >
                                            <span
                                                v-if="
                                                    availableInventory <
                                                        productItem.node
                                                            .quantity
                                                "
                                                class="error--text"
                                            >
                                                {{ availableInventory }}
                                                <v-icon class="ml-1 error--text"
                                                    >warning</v-icon
                                                >
                                            </span>
                                            <span v-else>{{
                                                availableInventory
                                            }}</span>
                                        </td>
                                        <td
                                            :set="
                                                (availableInventory = getCustomerAvailableInventory(
                                                    productItem.node
                                                ))
                                            "
                                        >
                                            <v-text-field
                                                v-model="
                                                    productItem.node.quantity
                                                "
                                                type="number"
                                                min="0"
                                                :max="availableInventory"
                                                :rules="[
                                                    rules.required,
                                                    rules.minNumber(0),
                                                    rules.maxNumber(
                                                        availableInventory
                                                    )
                                                ]"
                                                label="Quantity*"
                                                outlined
                                                hide-details
                                                class="centered-input subtitle-2 my-2"
                                            ></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="subtitle-2">Total</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td class="subtitle-2 text-center">
                                            <span
                                                v-if="
                                                    totalSinglePlantQuantity ==
                                                        salesOrderProduct.quantity
                                                "
                                                >{{
                                                    totalSinglePlantQuantity
                                                }}</span
                                            >
                                            <span v-else class="red--text">{{
                                                totalSinglePlantQuantity
                                            }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="pb-5 pr-5">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="onCancelled">Cancel</v-btn>
                    <v-btn
                        outlined
                        rounded
                        :loading="isSaving"
                        color="primary"
                        :disabled="
                            !valid ||
                                totalSinglePlantQuantity !=
                                    salesOrderProduct.quantity
                        "
                        @click="saveProductPlants()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-form>

            <!-- multiple plants container -->
            <v-form ref="form" v-model="valid" v-else>
                <!-- Product Items -->
                <v-card-text v-if="salesOrderProduct.product">
                    <v-row class="mx-0">
                        <v-col cols="12">
                            <v-simple-table class="mx-0">
                                <thead>
                                    <tr>
                                        <th class="text-left">Priority</th>
                                        <th class="text-left">Plant</th>
                                        <th class="text-left">Pot Size</th>
                                        <th class="text-left">Color</th>
                                        <th class="text-left">Environment</th>
                                        <th class="text-left">Tag</th>
                                        <th class="text-right">Inventory</th>
                                        <th class="text-right">Available</th>
                                        <th class="text-center">#Containers</th>
                                        <th
                                            class="text-center"
                                            style="min-width: 90px"
                                        >
                                            #Plants
                                        </th>
                                        <th class="text-left">Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(productItem,
                                        index) in salesOrderProduct.product
                                            .productItemSet.edges"
                                        :key="index"
                                    >
                                        <td>{{ productItem.node.priority }}</td>
                                        <td>
                                            {{ productItem.node.plant.name }}
                                        </td>
                                        <td>
                                            {{
                                                productItem.node.potSize
                                                    .potSizeCm
                                            }}
                                            cm
                                        </td>
                                        <td>
                                            {{ productItem.node.color.color }}
                                        </td>
                                        <td>
                                            {{
                                                productItem.node.environment
                                                    .environment
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                productItem.node.tag
                                                    ? productItem.node.tag.tag
                                                    : "-"
                                            }}
                                        </td>
                                        <td
                                            class="text-right"
                                            :set="
                                                (plantInventory = getAvailableInventory(
                                                    productItem.node
                                                ))
                                            "
                                        >
                                            <span
                                                v-if="
                                                    plantInventory <
                                                        numOfContainers *
                                                            (productItem.node
                                                                .quantityPerContainer ||
                                                                0)
                                                "
                                                class="error--text"
                                            >
                                                {{ plantInventory }}
                                                <v-icon class="ml-1 error--text"
                                                    >warning</v-icon
                                                >
                                            </span>
                                            <span v-else>{{
                                                plantInventory
                                            }}</span>
                                        </td>
                                        <td
                                            class="text-right"
                                            :set="
                                                (availableInventory = getCustomerAvailableInventory(
                                                    productItem.node
                                                ))
                                            "
                                        >
                                            <span
                                                v-if="
                                                    availableInventory <
                                                        numOfContainers *
                                                            (productItem.node
                                                                .quantityPerContainer ||
                                                                0)
                                                "
                                                class="error--text"
                                            >
                                                {{ availableInventory }}
                                                <v-icon class="ml-1 error--text"
                                                    >warning</v-icon
                                                >
                                            </span>
                                            <span v-else>{{
                                                availableInventory
                                            }}</span>
                                        </td>
                                        <td class="text-center">
                                            {{ numOfContainers }} x
                                        </td>
                                        <td
                                            class="text-center"
                                            :set="
                                                (availableInventory = getCustomerAvailableInventory(
                                                    productItem.node
                                                ))
                                            "
                                        >
                                            <v-text-field
                                                v-model="
                                                    productItem.node
                                                        .quantityPerContainer
                                                "
                                                type="number"
                                                min="0"
                                                :max="
                                                    availableInventory /
                                                        numOfContainers
                                                "
                                                :rules="[
                                                    rules.required,
                                                    rules.minNumber(0),
                                                    rules.maxNumber(
                                                        availableInventory /
                                                            numOfContainers
                                                    )
                                                ]"
                                                outlined
                                                hide-details
                                                class="centered-input subtitle-2 my-2 ml-1"
                                            ></v-text-field>
                                        </td>
                                        <td class="text-left">
                                            =
                                            {{
                                                numOfContainers *
                                                    (productItem.node
                                                        .quantityPerContainer ||
                                                        0)
                                            }}
                                        </td>
                                        <!-- <td
                                            :set="plantInventory = productItem.node.availableSalesInventory + getSelectedPlantQuantity(productItem.node.id, salesOrderProduct.salesOrderPlantSet)"
                                        >
                                            <v-text-field
                                                v-model="productItem.node.quantity"
                                                type="number"
                                                min="0"
                                                :max="plantInventory"
                                                :rules="[rules.required, rules.minNumber(0), rules.maxNumber(plantInventory)]"
                                                label="Quantity*"
                                                outlined
                                                hide-details
                                                class="subtitle-2 my-2"
                                            ></v-text-field>
                                        </td>-->
                                    </tr>
                                    <tr>
                                        <td class="subtitle-2">Total</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td class="subtitle-2 text-center">
                                            {{ numOfContainers }} x
                                        </td>
                                        <td class="subtitle-2 text-center">
                                            <span
                                                v-if="
                                                    totalSelectedPlantQuantityPerContainer ==
                                                        salesOrderProduct.quantityPerContainer
                                                "
                                                >{{
                                                    totalSelectedPlantQuantityPerContainer
                                                }}</span
                                            >
                                            <span v-else class="red--text">{{
                                                totalSelectedPlantQuantityPerContainer
                                            }}</span>
                                        </td>
                                        <td class="subtitle-2 text-left">
                                            =
                                            <span
                                                v-if="
                                                    totalSelectedPlantQuantity ==
                                                        salesOrderProduct.quantity
                                                "
                                                >{{
                                                    totalSelectedPlantQuantity
                                                }}</span
                                            >
                                            <span v-else class="red--text">{{
                                                totalSelectedPlantQuantity
                                            }}</span>
                                        </td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="pb-5 pr-5">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="onCancelled">Cancel</v-btn>
                    <v-btn
                        outlined
                        rounded
                        :loading="isSaving"
                        color="primary"
                        :disabled="
                            !valid ||
                                totalSelectedPlantQuantity !=
                                    salesOrderProduct.quantity
                        "
                        @click="saveProductPlants()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-form>
        </v-card>
    </v-container>
</template>


<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";

export default {
    name: "sales-order-product-editor-component",
    props: ["salesOrderProductNodeId", "customer"],
    components: {},

    apollo: {
        salesOrderProduct: {
            query: gql`
                query salesOrderProduct($id: ID!) {
                    salesOrderProduct(id: $id) {
                        id
                        quantity
                        quantityPerContainer
                        isReady
                        isManualConfig
                        salesOrder {
                            id
                            customer {
                                id
                                name
                            }
                        }
                        salesOrderPlantSet {
                            edges {
                                node {
                                    id
                                    quantity
                                    productItem {
                                        id
                                    }
                                }
                            }
                        }
                        product {
                            id
                            name
                            productItemSet {
                                edges {
                                    node {
                                        id
                                        numPlants
                                        plant {
                                            id
                                            name
                                        }
                                        potSize {
                                            id
                                            potSizeCm
                                        }
                                        color {
                                            id
                                            color
                                        }
                                        environment {
                                            id
                                            environment
                                        }
                                        tag {
                                            id
                                            tag
                                        }
                                        priority
                                        growthTasks {
                                            id
                                            lockedForCustomer {
                                                id
                                                name
                                            }
                                            totalInventory
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    id: this.salesOrderProductNodeId
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update(data) {
                //send data to parent component
                this.$emit("item-fetched", data.salesOrderProduct);

                // calculate selected plants quantity
                let _productItemSetWithQuantity = data.salesOrderProduct.product.productItemSet.edges.map(
                    item => {
                        return {
                            node: {
                                ...item.node,
                                customerAvailabelInventory: 0,
                                quantity: this.getSelectedPlantQuantity(
                                    item.node.id,
                                    data.salesOrderProduct.salesOrderPlantSet
                                ),
                                quantityPerContainer:
                                    data.salesOrderProduct
                                        .quantityPerContainer == 1
                                        ? 1
                                        : Math.round(
                                              (this.getSelectedPlantQuantity(
                                                  item.node.id,
                                                  data.salesOrderProduct
                                                      .salesOrderPlantSet
                                              ) *
                                                  data.salesOrderProduct
                                                      .quantityPerContainer) /
                                                  data.salesOrderProduct
                                                      .quantity
                                          ) || 0
                            }
                        };
                    }
                );

                data.salesOrderProduct.product.productItemSet.edges = _productItemSetWithQuantity;

                // sort by product item priority
                data.salesOrderProduct.product.productItemSet.edges = data.salesOrderProduct.product.productItemSet.edges.sort(
                    (a, b) => {
                        return a.node.priority - b.node.priority;
                    }
                );

                //return result to current componet
                return data.salesOrderProduct;
                // return JSON.parse(JSON.stringify(data.product));
            }
            // skip: true,
            // pollInterval: 60000 // ms
        }
    },

    data() {
        return {
            valid: true,
            isSaving: false,

            salesOrderProduct: {
                quantity: 0,
                product: {
                    productItemSet: {
                        edges: []
                    }
                },
                salesOrderPlantSet: {}
            },
            rules: {
                required: v => !helper.isEmpty(v) || "This field is required",
                minLength: len => v =>
                    (v || "").length >= len ||
                    `Invalid character length, required ${len}`,
                maxLength: len => v => (v || "").length <= len || "Too long",
                minNumber: limit => v => v >= limit || `Min number ${limit}`,
                maxNumber: limit => v => v <= limit || `Max number ${limit}`
                // nameRules: [
                //     v => !!v || "Name is required",
                //     v =>
                //         v.length <= 50 || "Name must be less than 50 characters"
                // ]
            }
        };
    },
    computed: {
        numOfContainers() {
            if (this.salesOrderProduct.quantityPerContainer === 0) {
                return 0;
            }

            return (
                this.salesOrderProduct.quantity /
                this.salesOrderProduct.quantityPerContainer
            );
        },
        totalSelectedPlantQuantity() {
            return (
                this.numOfContainers *
                this.totalSelectedPlantQuantityPerContainer
            );
        },
        totalSelectedPlantQuantityPerContainer() {
            if (
                this.salesOrderProduct.product.productItemSet.edges.length == 0
            ) {
                return 0;
            }

            return this.salesOrderProduct.product.productItemSet.edges.reduce(
                function(accumulator, item) {
                    return (
                        accumulator +
                        (parseInt(item.node.quantityPerContainer) || 0)
                    );
                },
                0
            );
        },
        totalSinglePlantQuantity() {
            if (
                this.salesOrderProduct.product.productItemSet.edges.length == 0
            ) {
                return 0;
            }

            return this.salesOrderProduct.product.productItemSet.edges.reduce(
                function(accumulator, item) {
                    return accumulator + (parseInt(item.node.quantity) || 0);
                },
                0
            );
        }
    },
    watch: {
        // salesOrderProductNodeId(val) {
        //     // console.log(val);
        //     if (val) {
        //         this.$apollo.queries.salesOrderProduct.skip = false;
        //     } else {
        //         this.$apollo.queries.salesOrderProduct.skip = true;
        //     }
        // }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    methods: {
        getSelectedPlantQuantity(productItemNodeId, salesOrderPlantSet) {
            if (salesOrderPlantSet.edges.length == 0) {
                return 0;
            }

            return salesOrderPlantSet.edges
                .filter(item => {
                    return item.node.productItem.id === productItemNodeId;
                })
                .reduce(function(accumulator, item) {
                    return accumulator + item.node.quantity;
                }, 0);
        },

        getAvailableInventory(productItem) {
            const _availableInventory = productItem.growthTasks.reduce(function(
                accumulator,
                item
            ) {
                return accumulator + (parseInt(item.totalInventory) || 0);
            },
            0);

            return this.salesOrderProduct.isManualConfig &&
                !this.salesOrderProduct.isReady
                ? _availableInventory
                : _availableInventory +
                      this.getSelectedPlantQuantity(
                          productItem.id,
                          this.salesOrderProduct.salesOrderPlantSet
                      );
        },

        getCustomerAvailableInventory(productItem) {
            const _customer = this.salesOrderProduct.salesOrder.customer;

            const _customerAvailableInventory = productItem.growthTasks
                .filter(item => {
                    return (
                        !item.lockedForCustomer ||
                        item.lockedForCustomer.id == _customer.id
                    );
                })
                .reduce(function(accumulator, item) {
                    return accumulator + (parseInt(item.totalInventory) || 0);
                }, 0);

            // console.log(_customerAvailableInventory);

            return this.salesOrderProduct.isManualConfig &&
                !this.salesOrderProduct.isReady
                ? _customerAvailableInventory
                : _customerAvailableInventory +
                      this.getSelectedPlantQuantity(
                          productItem.id,
                          this.salesOrderProduct.salesOrderPlantSet
                      );
        },

        onCancelled() {
            this.$emit("cancelled");
        },

        // calculatePlantSalesInventory(tenantGrowthTasks) {
        //     var sum = 0;

        //     var orderCustomer = this.customer;

        //     tenantGrowthTasks.edges.forEach((e) => {
        //         if (!e.node.lockedForCustomer) {
        //             sum += e.node.totalInventory;
        //         } else if (
        //             orderCustomer &&
        //             e.node.lockedForCustomer.id == orderCustomer.id
        //         ) {
        //             sum += e.node.totalInventory;
        //         }
        //     });

        //     return sum;
        // }

        saveProductPlants() {
            // console.log(salesOrderItem);

            this.isSaving = true;

            let productPlants = this.salesOrderProduct.product.productItemSet.edges
                .map(item => {
                    return {
                        productItemNodeId: item.node.id,
                        quantity:
                            this.salesOrderProduct.quantityPerContainer == 1
                                ? item.node.quantity
                                : (parseInt(item.node.quantityPerContainer) ||
                                      0) * this.numOfContainers
                    };
                })
                .filter(item => item.quantity > 0);

            this.$apollo
                .mutate({
                    // Query
                    mutation: gql`
                        mutation updateSaelsOrderProductPlants(
                            $input: UpdateSalesOrderProductPlantsInput!
                        ) {
                            updateSaelsOrderProductPlants(input: $input) {
                                salesOrderProduct {
                                    id
                                    quantity
                                    quantityPerContainer
                                    externalContainer
                                    isPlantsConfirmed
                                    isManualConfig
                                    isReady
                                    salesOrderPlantSet {
                                        totalCount
                                        edges {
                                            node {
                                                id
                                                productItem {
                                                    id
                                                }
                                                quantity
                                                numPlantsPerProduct
                                                isReady
                                                plant {
                                                    id
                                                    name
                                                }
                                                potSize {
                                                    id
                                                    potSizeCm
                                                }
                                                color {
                                                    id
                                                    color
                                                }
                                                environment {
                                                    id
                                                    environment
                                                }
                                                tag {
                                                    id
                                                    tag
                                                }
                                            }
                                        }
                                    }
                                    product {
                                        id
                                        isDynamic
                                        name
                                        externalCode
                                        externalPotsize
                                        externalHeight
                                        externalCover
                                        externalLabel
                                        externalSticker
                                        isPlantsConfigured
                                        numColorsPerUnitMax
                                        numColorsPerUnitMin
                                        numMixPlantsPerUnitMin
                                        numMixPlantsPerUnitMax
                                        productItemSet {
                                            totalCount
                                            edges {
                                                node {
                                                    id
                                                    priority
                                                    numPlants
                                                    plant {
                                                        id
                                                        name
                                                    }
                                                    potSize {
                                                        id
                                                        potSizeCm
                                                    }
                                                    color {
                                                        id
                                                        color
                                                    }
                                                    tag {
                                                        id
                                                        tag
                                                    }
                                                    environment {
                                                        id
                                                        environment
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        input: {
                            salesOrderProductNodeId: this
                                .salesOrderProductNodeId,
                            productPlants: productPlants
                        }
                    }
                })
                .then(() => {
                    // Result
                    // console.log(response.data);
                    // salesOrderItem.node = response.data.salesOrderProduct;

                    // show snackbar
                    const payload = {
                        color: "success",
                        message: `Order is saved!`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);

                    this.$emit("saved");
                })
                .catch(error => {
                    // Error
                    console.error(error);
                    // We restore the initial user input
                    // this.newTag = newTag;

                    const payload = {
                        color: "error",
                        message: `${error}`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);
                })
                .finally(() => {
                    this.isSaving = false;
                });
        }
    }
};
</script>

<style scoped>
.centered-input >>> input {
    text-align: center;
}
</style>